import { z } from 'zod'

export const MatterWhereYouLeftOffStateSchema = z
  .object({
    sentence: z.string().trim().min(1),
  })
  .strict()

export const MatterWhereYouLeftOffResponseSchema = MatterWhereYouLeftOffStateSchema.nullable()

export type MatterWhereYouLeftOffState = z.infer<typeof MatterWhereYouLeftOffStateSchema>
export type MatterWhereYouLeftOffResponse = z.infer<typeof MatterWhereYouLeftOffResponseSchema>
